/**
 * Scroll math for the glass-stack section (Legora-style pinned scrub).
 * Pure functions so the segment/assembly logic is unit-testable without
 * a DOM or scroll events.
 */

export function clamp01(v: number): number {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

/** Which layer's segment the overall progress is in. */
export function activeLayerIndex(progress: number, count: number): number {
  if (count <= 0) return 0;
  return Math.min(count - 1, Math.floor(clamp01(progress) * count));
}

/**
 * Per-layer assembly progress: layer `index` animates from 0 → 1 during its
 * own segment of the overall scroll (layer 0 first, layer count-1 last).
 */
export function layerProgress(progress: number, index: number, count: number): number {
  return clamp01(clamp01(progress) * count - index);
}

export function easeOutCubic(t: number): number {
  return 1 - Math.pow(1 - clamp01(t), 3);
}

/**
 * Remap overall scroll progress so assembly completes at `end` (0..1) and the
 * remaining scroll is a dwell on the finished stack — the section doesn't
 * snap away the instant the last layer lands.
 */
export function assemblyProgress(progress: number, end = 0.85): number {
  if (end <= 0) return 1;
  return clamp01(clamp01(progress) / end);
}
